module.exports = __webpack_public_path__ + "static/media/search.cff0f990.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/svod/search.png
// module id = 609
// module chunks = 0